import { Box } from "@mui/material";
import BreadcrumbsComponent from "../component/base/Breadcrumbs.component";
import EditDealershipTabs from "../component/app/admin/dealership/EditDealershipTabs.component";

const EditDealershipPage = () => {
  const breadcrumb = {
    title: "Edit Dealership",
    links: [{ path: "/", name: "" }],
  };

  return (
    <>
      <BreadcrumbsComponent {...breadcrumb} />
      <Box>
        <EditDealershipTabs />
      </Box>
    </>
  );
};
export default EditDealershipPage;
